import { valtioDevTools } from '@lib/utils/devTools';
import { proxy } from 'valtio';
import {
  DialerState,
  PhoneState,
  WebphoneCallState,
  WebphoneConnectionStatus,
} from './types';
import { RecordingStatus } from './types';

export const defaultCallState: WebphoneCallState = {
  connected: false,
  callId: '',
  direction: '',
  ended: false,
  established: false,
  hasSession: false,
  held: false,
  inTransfer: false,
  isAudioMuted: false,
  isVideoMuted: false,
  localIdentity: '',
  originating: false,
  primary: false,
  progress: false,
  remoteIdentity: '',
  terminating: false,
  registrationFailed: false,
  internalCall: false,
  remoteCallId: '',
  lastTriggeringEvent: '',
};

export const defaultCallAttributes = {
  pcsConversationSid: '',
  queueIds: [],
  recordingState: {
    status: RecordingStatus.NoRecording,
    disabled: true,
  },
  traits: [],
  tenantId: '',
};

export const dialerState = proxy<DialerState>({
  actionDisplay: '',
  actionColor: '#093',
  dialedNumbers: '',
});

valtioDevTools(dialerState, 'dialerState');

export const phoneState = proxy<PhoneState>({
  phoneConnected: false,
  connectionStatus: WebphoneConnectionStatus.Uninitialized,
  registrationFailed: false,
  callList: [],
  callAttributes: {},
  registrationOverwritten: false,
  /** callsAccepting holds the callIds for any calls that have been accepted, but waiting for the session delivered, it will be used to determine if we should show a loading state. */
  callsAccepting: [],
  disconnectTriggeredLocally: false,
  debugInfo: {},
  existingRegistrationsDetected: false,
  isUnactivatedImpersonator: true,
});

valtioDevTools(phoneState, 'phoneState');

export const phoneStateHasCallEstablished = (): boolean => {
  const calls = Object.values(phoneState.callList);

  return calls.some((call) => call.established || call.hasSession);
};

export const phoneStateCallExists = (callId: string): boolean => {
  return !!phoneState.callList.find((call) => call.callId === callId);
};
